export default __webpack_public_path__ + "static/media/1905.372e3a66.png";